commusoftCommon.filter('dayMonYear', function () {
    return function (dateString) {
        if (dateString == '' || dateString == undefined) {
            return '';
        }
        return moment(dateString).format('ddd Do MMM YYYY')
    };
});